import { useMatch } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

import { IconSidebar } from '@yakit/ui-components';
import { VDLSidebarElement } from '@VDL/components/VDLSidebarElement/VDLSidebarElement';

import { useVDLStore } from '@VDL/store/VDLstore';

import { TooltipProvider } from '@yakit/ui-components';

export const VDLSidebar = () => {
  const match = useMatch('/:level0Code');
  const { level0Data, sidebarExpanded, setSidebarExpanded } = useVDLStore();

  if (!match) return;

  return (
    <IconSidebar
      listForIcons={level0Data?.data ?? []}
      expanded={sidebarExpanded}
      onToggleExpanded={() => setSidebarExpanded(!sidebarExpanded)}
      renderIcon={({ item: levelObject }) => (
        <Fragment key={levelObject.code}>
          <TooltipProvider>
            <VDLSidebarElement
              expanded={sidebarExpanded}
              levelObject={levelObject}
            />
          </TooltipProvider>
        </Fragment>
      )}
    />
  );
};
